<template>
    <vl-form-message-label :for="labelFor" :class="{'vl-u-visually-hidden': modHiddenLabel}" v-html="parsedLabel"/>
    <slot :has-errors="hasError"></slot>
    <vl-form-message-annotation v-if="annotation" :class="{'vl-form__annotation--no-wrap': modNoWrapAnnotation}"
                                v-html="annotation"></vl-form-message-annotation>
    <vl-form-message-error v-if="hasError" :class="{'vl-form__error--no-wrap': modNoWrapError}">
        {{ errorMessage }}
    </vl-form-message-error>
</template>

<script lang="ts">

import {computed, defineComponent} from 'vue';
import {FieldContext} from 'vee-validate';
import {concat, first} from 'lodash-es';

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlFieldValidationWrapperYup',
    components: {},
    props: {
        field: {type: Object as () => { key: string; label: string; field: FieldContext }, required: true},
        name: {type: String, required: false, default: undefined},
        for: {type: String, required: false, default: undefined},
        modHiddenLabel: {type: Boolean, default: false, required: false},

        manualErrorMessages: {type: Array<string>, default: null},

        // TO REVIEW
        annotation: {type: String, required: false, default: undefined},
        modRequired: {type: Boolean, default: false, required: false},
        modNoWrapError: {type: Boolean, default: false, required: false},
        modNoWrapAnnotation: {type: Boolean, default: false, required: false},
    },
    setup(props) {
        const errorMessage = computed(() => first(concat(props.field.field.errors.value, props.manualErrorMessages)));
        const hasError = computed((): boolean => !!errorMessage.value);
        const label = computed((): string => props.name || props.field.label);

        const labelFor = computed((): string => {
            return props.for;
        })

        const parsedLabel = computed((): string => {
            return `${label.value}${props.modRequired ? '&nbsp;*' : ''}`;
        });

        return {
            parsedLabel,
            labelFor,
            hasError,
            errorMessage
        }
    }
})

</script>